<template>
  <div id="app" v-resize:debounce="onResize">
    <keep-alive>
      <Compass :class="{compassActive: transitions}"></Compass>
    </keep-alive>

    <transition name="fade">
    <div class="main_wrapper">
      <div class="content">
        <router-view/>
      </div>
      <Menu v-if="$route.name != 'Home' && $store.state.menuInstruction === false"></Menu>
    </div>
    </transition>
  </div>
</template>

<script>
import Menu from './components/library/menu.vue'
import resize from 'vue-resize-directive'
// import Rain from './components/library/rain.vue'
import Cloud from './components/library/cloud.vue'
import Sun from './components/library/sun.vue'
import Compass from './components/library/compass.vue'

export default {
  name: 'App',
  directives: {
      resize,
  },
  components: {
      Menu,
      Compass,
      // Rain,
      Cloud,
      Sun
  },
  computed: {
    storeClassBody () {
      return this.$store.state.classBody
    },
    transitions () {
      return this.$store.state.compass
    }
  },
  created () {
    this.$store.dispatch('LOAD_DATASET')
  },
  watch: {
    storeClassBody: function () {
      document.body.className = this.storeClassBody
    }
  },
  methods: {
    onResize: function () {
      this.$store.state.docHeight = document.getElementById("app").clientHeight
    }
  },
}
</script>

<style lang="less">
  @import "styles/global.less";
  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }
</style>


// WEBPACK FOOTER //
// src/App.vue